import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import customReportCat from '../../../data/statements.json';
import DetectBrowser from '../../../../../../src/muster/app/auth/detectBrowser';
import { NavigationList, NavigationListItem, NavigationListItemHeader } from '@dbk/ui-list';
import Text from '@dbk/ui-text';
import { TouchableOpacity } from 'react-native';

class ReportCustom extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedItem: 0
    };
  }

  /**
 * function: onRowClick will be called from Navigation List item.
 * It will route the screen to detail view of category list.
 */
  onRowClick = (index) => {
    this.props.reports.custom.setSelectedCustomReportType(index);
    this.setState({ selectedItem: index });
  }


  renderReportItem(statement) {
    const { key, title } = statement;
    const { i18n: { messages } } = this.props;
    return (

      <View fullWidth style={{ paddingLeft: 20, paddingRight: 20, paddingBottom: 5 }}>
          <TouchableOpacity>
          <NavigationListItem testID={"list_report_lefttab_reportCustom_test_" + statement.index}
            inverse
            selected={this.state.selectedItem === statement.index}
            style={this.state.selectedItem === statement.index ? { borderColor: "#d37130", height:90 } : {height:90}}
            onClick={() => this.onRowClick(statement.index)}  >
            <NavigationListItemHeader>
             {messages[title]}
            </NavigationListItemHeader>
          </NavigationListItem>
          </TouchableOpacity >
      </View>

    );
  }

  render() {
    const trans = customReportCat.transactionList;
    return (
      <div>
        {trans.map((item) => (
          this.renderReportItem(item)
        ))}

      </div>
    );
  }
}

ReportCustom.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
};

ReportCustom.defaultProps = {
  i18n: {},
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    reports: {
      custom: {
        setSelectedCustomReportType: {
          $set: 'selectedCustomReportType'
        }
      }
    },

    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
  },
})(ReportCustom);
